import React from 'react';
import {connect} from 'react-redux';
import { Grid, Tab } from 'semantic-ui-react'

import SiteInstallations from '../SiteInstallations/SiteInstallations';
import {
  fetchInstallations,
  fetchInstallationsFilters,
  emptyInstallationsSection
} from '../../redux/actions';
import CollectionBanking from '../SiteInstallations/CollectionBanking';
import CollectionPerformance from '../SiteInstallations/CollectionPerformance';
import VarianceHistory from '../SiteInstallations/VarianceHistory';
import MachineCounts from '../SiteInstallations/MachineCounts';

class SiteInstallationsView extends React.Component {

  state = {
    currentOrganisationId: 0,
  };

  getPanes = () => {
    const panes = [];

    const { optionShowInstCollectionTabs, optionShowInstVarianceTab, optionShowInstCountDetailsTab } = this.props.logIn

    if (optionShowInstCollectionTabs) {
      panes.push({
        menuItem: 'Collection - Banking',
        pane: <Tab.Pane>
          <CollectionBanking
            operator={this.props.filters.filterSelected.operator}
            siteId={this.props.filters.filterSelected.site.id}
          />
        </Tab.Pane>
      });

      panes.push({
        menuItem: 'Collection - Net Income',
        pane: <Tab.Pane>
          <CollectionPerformance
            operator={this.props.filters.filterSelected.operator}
            siteId={this.props.filters.filterSelected.site.id}
          />
        </Tab.Pane>
      });
    }

    if (optionShowInstVarianceTab) {
      panes.push({
        menuItem: 'Site Variance',
        pane: <Tab.Pane><VarianceHistory
          operator={this.props.filters.filterSelected.operator}
          siteId={this.props.filters.filterSelected.site.id}
        /></Tab.Pane>
      });
    }

    if (optionShowInstCountDetailsTab) {
      panes.push({
        menuItem: 'Machine Counts',
        pane: <Tab.Pane><MachineCounts
          operator={this.props.filters.filterSelected.operator}
          siteId={this.props.filters.filterSelected.site.id}
        /></Tab.Pane>
      });
    }


    return panes;
  }

  render() {
    const panes = this.getPanes()

    const expanded = this.state.expanded || !this.props.filters.filterSelected.operator || !this.props.filters.filterSelected.site.id;

    return (
      <div className="gs-flex-container-vertical h-100">
        <SiteInstallations
          showOrgTree={this.props.showOrgTree}
          organisationId={this.props.filters.filterSelected.site.id}
          handleExpand={() => this.setState({ expanded: !expanded })}
          expanded={expanded}
        />
        { (!expanded && panes.length > 0) &&
             <Tab renderActiveOnly={false} panes={panes} installation={this.state.activeInstallation} className="flex-stretch gs-flex-container-vertical mt-1 h-100" /> 
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
	return {
    filters: state.installationsFilters,
    logIn: state.logIn
  };
};

export default connect(mapStateToProps, {
  fetchInstallations,
  fetchInstallationsFilters,
  emptyInstallationsSection
})(SiteInstallationsView);
